<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Címek</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        @click="onCreate"
        icon="el-icon-plus"
      >
        Új cím
      </el-button>
    </div>
    <el-alert
      v-if="!addresses || !addresses.length"
      title="Ehhez a partnerhez még nem tartozik cím. Adj hozzá egyet."
      type="info"
      show-icon
      :closable="false"
    />
    <el-table
      :data="addresses"
      v-if="addresses && addresses.length"
    >
      <el-table-column
        prop="address"
        label="Cím"
        show-overflow-tooltip
        width="420px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.country">{{ scope.row.country.name }} </span>{{ scope.row.postal_code }} {{ scope.row.city }}, {{ scope.row.address }}
        </template>
      </el-table-column>
      <el-table-column
        prop="gln_number"
        label="GLN szám"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.pivot && scope.row.pivot.gln_number">{{ scope.row.pivot.gln_number }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="type"
        align="right"
        label="Típus"
        width="120"
      >
        <template slot-scope="scope">
          <el-tag size="small">{{ getType(scope.row.pivot.type) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <address-actions :address="scope.row" @update="onUpdate" @delete="onDelete" />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="addressFormType === 'add' ? 'Új cím' : 'Cím módosítás'"
      @close="onClose"
      append-to-body
      :close-on-click-modal="false"
      width="550px"
    >
      <address-form ref="addressForm" :defaultAddress="selectedAddress" :formType="addressFormType"/>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeAddress"
        >
          {{ addressFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import AddressForm from './Address';
import AddressActions from './AddressActions';

export default {
  components: {
    AddressForm,
    AddressActions
  },
  props: ['addresses'],
  data() {
    return {
      showDialog: false,
      dialogType: 'add',
      addressFormType: 'add',
      selectedAddress: {
        pivot: {},
      },
    };
  },
  methods: {
    onClose() {
      this.$refs.addressForm.address = {};
      this.$refs.addressForm.types = [];
      this.$refs.addressForm.type = null;
      this.$refs.addressForm.$refs.addressForm.resetFields();
      this.showDialog = false;
    },
    onCreate() {
      this.addressFormType = 'add';
      this.selectedAddress = {
        pivot: {},
      };
      this.showDialog = true;
    },
    onUpdate(address) {
      this.selectedAddress = Object.assign({}, address);
      this.addressFormType = 'update';
      this.showDialog = true;
    },
    onDelete(address) {
      const addresses = this.addresses.filter(a => ((a.id && a.id !== address.id) || a.key !== address.key));
      this.$emit('change', addresses);
    },
    async storeAddress() {
      this.$refs['addressForm'].$refs['addressForm'].validate(async valid => {
        if(valid){
          const address = this.$refs.addressForm.address;
          if (this.addressFormType === 'add') {
            const types = this.$refs.addressForm.types;
            for (const type of types) {
              let gln_number = this.$refs.addressForm.address.pivot.gln_number;
              const newAddress = {
                ...address,
                country_id: address.country && address.country.id || null,
                county_id: address.county && address.county.id || null,
                pivot: { type, gln_number },
                key: Math.random().toString(36).substring(7) + type,
              };
              this.$emit('add', newAddress);
            }
          } else {
            const type = this.$refs.addressForm.type;
            const gln_number = type === 'delivery' ? this.$refs['addressForm'].address.pivot.gln_number : null;
            const addresses = this.addresses.map(a => {
              if ((a.id && a.id === address.id) || (a.key && a.key === address.key)) {
                return {
                  ...address,
                  country_id: address.country && address.country.id || null,
                  county_id: address.county && address.county.id || null,
                  pivot: { type, gln_number },
                };
              } else {
                return a;
              }
            });
            this.$emit('change', addresses);
          }
          this.showDialog = false;
        }
      });
    },
    getType(id) {
      switch (id) {
        case 'billing':
          return 'számlázási';
          break;
        case 'delivery':
          return 'szállítási';
          break;
        case 'mailing':
          return 'levelezési';
          break;
      }
    },
  },
};
</script>
